import _ from 'lodash';
import CloseModal from 'actions/modal/close_modal';
import { DomainError } from 'scripts/application/lib/error';
import Err from 'models/err';
import { handleCommonErrors } from 'scripts/application/lib/gateway_error_interactive_handler';
import ShowToast from 'actions/toast_deprecated/show_toast';
import { ToastType } from 'models/toast_deprecated';

export default class ScheduledReportGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  get store() {
    return this.context.stores.scheduledReport;
  }

  onAddSuccess(dto) {
    this.context.executeAction(CloseModal);

    const reportName = _.get(dto, 'reportParameters.name', '');
    this.context.executeAction(ShowToast, {
      type: ToastType.SUCCESS,
      message: reportName === '' ? 'Report successfully scheduled.' : `"${reportName}" report scheduled.`,
      link: '/admin/scheduled-reports',
    });

    this.store.resetPending();
  }

  onAddError(err) {
    this.store.resetPending();

    if (err instanceof DomainError) {
      const isNotConfigured = err.errors.some(e => e.code === Err.Code.INVALID_STATE && e.attr == null);
      if (isNotConfigured) {
        this.context.executeAction(CloseModal);
        this.context.executeAction(ShowToast, {
          type: ToastType.ERROR,
          message: 'Report scheduling is not configured for your organization. Contact Gladly support.',
        });

        return;
      }

      this.store.setErrors(err.errors);
    } else {
      handleCommonErrors(this.context, err);
    }
  }
}
